<template>
  <card-dialog
    v-model="modalVisible"
    max-width="700px"
    :title="playlistDirty.id ? 'Edit Marketing Campaign' : 'Add New Marketing Campaign'"
  >
    <template v-slot:title>
      <v-card-title class="grey-bg px-6 py-3">
        <div>
          <div>
            {{ playlistDirty.id ? 'Edit Marketing Campaign' : 'Add New Marketing Campaign' }}
          </div>
          <div class="body-2">
            Client: <strong>{{ client.name }}</strong>
          </div>
        </div>
      </v-card-title>
    </template>
    <v-card-text
      id="handleDropUpload"
      class="pa-6"
    >
      <validation-observer ref="validation">
        <div class="mb-2 font-weight-bold">
          Campaign Title
        </div>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <v-text-field
            v-model="playlistDirty.title"
            outlined
            :error-messages="errors"
            placeholder="Enter campaign title"
          />
        </validation-provider>

        <div class="mb-2 font-weight-bold">
          Advertisements
        </div>

        <div v-if="currentLibraryFiles.length > 0">
          <div
            v-for="file in currentLibraryFiles"
            :key="file.id"
            class="grey-bg elevation-5 mb-2 rounded overflow-hidden"
          >
            <div class="px-3 py-2">
              <v-row no-gutters>
                <v-col
                  cols="auto"
                  class="pr-2"
                >
                  <v-icon
                    x-small
                    @click="playAv(file)"
                  >
                    fa {{ file.isPlayingAv ? 'fa-stop' : 'fa-play' }}
                  </v-icon>
                </v-col>
                <v-col
                  class="text-truncate pr-3"
                  style="min-width: 0"
                >
                  {{ file.original_file }}
                </v-col>
                <v-col cols="auto" />
                <v-col cols="auto">
                  {{ file.size }}
                </v-col>
                <v-col
                  cols="auto"
                  class="pl-3"
                >
                  <v-icon
                    color="error"
                    @click="removeCurrentLibraryFile(file)"
                  >
                    fa fa-times
                  </v-icon>
                </v-col>
                <div
                  ref="wrapper"
                  class="file-av-wrapper"
                />
              </v-row>
            </div>
          </div>
        </div>

        <validation-provider
          v-slot="{ errors }"
          :rules="{ 'required': !playlist.id || playlist.library_files.length === 0 }"
        >
          <file-uploader
            ref="fileUploader"
            v-model="filesDirty"
            custom-drag-handler="#handleDropUpload"
            multiple
            accept="audio/*"
            :upload-url="uploadUrl"
            :additional-form-data="{ type: 'advertisement', client_id: client.id }"
            @drag:show="dropFilesOverlay = true"
            @drag:hide="dropFilesOverlay = false"
          />
          <div
            v-if="errors.length > 0"
            class="caption error--text"
          >
            {{ errors[0] }}
          </div>
        </validation-provider>

        <!--        <div class="mb-2 mt-6 font-weight-bold">-->
        <!--          Campaign Description-->
        <!--        </div>-->
        <!--        <v-textarea-->
        <!--          v-model="playlistDirty.description"-->
        <!--          placeholder="Enter description"-->
        <!--          outlined-->
        <!--        />-->

        <v-row
          no-gutters
          class="mb-2 mt-5"
        >
          <v-col class="font-weight-bold">
            Dates Active
          </v-col>
          <v-col
            cols="auto"
          >
            <v-chip
              small
              :dark="dateCurrentlyActive"
              :color="dateCurrentlyActive ? 'success darken-2' : 'grey lighten-3'"
            >
              <v-icon
                x-small
                left
              >
                fa {{ dateCurrentlyActive ? 'fa-check' : 'fa-times' }}
              </v-icon>
              {{ dateCurrentlyActive ? 'Active Now' : 'Inactive Now' }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pr-2">
            <validation-provider
              v-slot="{ errors }"
            >
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="playlistDirty.active_from ? $dayjs(playlistDirty.active_from).format('DD.MM.YYYY.') : ''"
                    placeholder="01.01.2019."
                    outlined
                    :error-messages="errors"
                    label="From"
                    clearable
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="playlistDirty.active_from = null"
                  />
                </template>
                <v-date-picker
                  v-model="playlistDirty.active_from"
                  @input="menu1 = false"
                />
              </v-menu>
            </validation-provider>
          </v-col>
          <v-col class="pl-2">
            <validation-provider
              v-slot="{ errors }"
            >
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="playlistDirty.active_until ? $dayjs(playlistDirty.active_until).format('DD.MM.YYYY.') : ''"
                    outlined
                    placeholder="31.12.2020."
                    :error-messages="errors"
                    label="To"
                    clearable
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="playlistDirty.active_until = null"
                  />
                </template>
                <v-date-picker
                  v-model="playlistDirty.active_until"
                  :min="playlistDirty.active_from ? playlistDirty.active_from : undefined"
                  @input="menu2 = false"
                />
              </v-menu>
            </validation-provider>
          </v-col>
        </v-row>
      </validation-observer>
      <v-overlay
        :value="dropFilesOverlay"
        absolute
        color="white"
        light
        opacity="0.7"
      >
        <div class="text-center grey--text text--darken-2 mb-4">
          <v-icon
            x-large
            color="grey darken-2"
          >
            fa fa-clipboard-list
          </v-icon>
        </div>
        <div class="title grey--text text--darken-2">
          Drop files here
        </div>
      </v-overlay>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-tooltip
          top
        >
          <template v-slot:activator="{ on }">
            <div
              class="d-inline-block"
              v-on="playlist.radios && playlist.radios.length > 0 ? on : undefined"
            >
              <v-btn
                v-if="playlistDirty.id"
                color="grey"
                outlined
                :disabled="playlist.radios && playlist.radios.length > 0"
                @click="toggleConfirmationDialog(true)"
              >
                <v-icon
                  left
                  small
                >
                  fa fa-trash
                </v-icon>
                Delete
              </v-btn>
            </div>
          </template>
          <span>
            Campaign is included in radios. Remove from radios before deleting.
          </span>
        </v-tooltip>
        <v-spacer />
        <div
          v-if="uploading"
          class="mr-4 body-2"
        >
          Uploading files...
        </div>
        <v-btn
          color="primary"
          :loading="submitting"
          @click="submit()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </template>

    <confirm-delete-dialog
      :visible="deleteConfirmationDialogVisible"
      :submitting="deleting"
      @confirm="deletePlaylist()"
    />
  </card-dialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'
import PlaylistModel from '@/models/PlaylistModel'
// eslint-disable-next-line no-unused-vars
import FileUploader from '@/components/helpers/FileUploader'
import ClockModel from '@/models/ClockModel'
import Playlists from '@/services/Playlists'

export default {
  name: 'EditMarketingCampaignDialog',
  components: { FileUploader, ConfirmDeleteDialog, CardDialog },
  mixins: [deleteConfirmationMixin],
  props: {
    playlist: {
      type: Object,
      default: () => cloneDeep(PlaylistModel.emptyModel)
    },
    client: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      playlistDirty: cloneDeep(this.playlist),
      filesDirty: [],
      currentLibraryFiles: [],
      dropFilesOverlay: false,
      submitting: false,
      uploading: false,
      deleting: false,
      menu1: false,
      menu2: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    dateCurrentlyActive() {
      const from = this.$dayjs(this.playlistDirty.active_from)
      const to = this.$dayjs(this.playlistDirty.active_until)

      if (!from.isValid() && !to.isValid()) return true

      const current = this.$dayjs()

      if (from.isValid() && from.isAfter(current)) return false
      if (to.isValid() && to.isBefore(current)) return false

      return true
    }
  },
  watch: {
    filesDirty(files) {
      if (files.length === 0 || this.playlistDirty.title) return

      this.playlistDirty.title = files[0].name()
    },
    modalVisible(value) {
      if (!value) return

      this.playlistDirty = cloneDeep(this.playlist)
      this.filesDirty = []
      this.currentLibraryFiles = []

      const activeFrom = this.$dayjs(this.playlistDirty.active_from)
      const activeUntil = this.$dayjs(this.playlistDirty.active_until)

      this.playlistDirty.active_from = activeFrom.isValid() ? activeFrom.format('YYYY-MM-DD') : null
      this.playlistDirty.active_until = activeUntil.isValid() ? activeUntil.format('YYYY-MM-DD') : null

      if (this.playlist.id) {
        this.currentLibraryFiles = this.playlist.library_files.map(f => {
          return {
            ...f,
            isPlayingAv: false,
            stopAv: null
          }
        })
      }

      if (this.$refs.validation) this.$refs.validation.reset()
    }
  },
  created() {
    // this.days = playlistModel.days
    this.PLAYBACK_TYPE_AFTER_SONGS = PlaylistModel.PLAYBACK_TYPE_AFTER_SONGS
    this.PLAYBACK_TYPE_AFTER_MINUTES = PlaylistModel.PLAYBACK_TYPE_AFTER_MINUTES

    this.CONTENT_TYPE_MARKETING = ClockModel.CONTENT_TYPE_MARKETING
    // this.fetchPlaylists()

    this.uploadUrl = process.env.VUE_APP_API_URL + '/library-files'
  },
  methods: {
    async submit() {
      if (!(await this.$refs.validation.validate())) {
        return
      }

      await this.save()
    },
    async save() {
      try {
        this.submitting = true

        if (this.filesDirty.length > 0) {
          this.uploading = true

          await this.$refs.fileUploader.performUpload()

          await this.$nextTick()

          this.uploading = false
        }

        const fileIds = [
          ...this.currentLibraryFiles.map(f => f.id),
          ...this.filesDirty.map(f => f.upload.data.id)
        ]

        if (fileIds.length === 0) {
          this.$store.dispatch('alert', {
            text: 'At least 1 file for playback is required',
            color: 'error'
          })
          return
        }

        const activeFrom = this.$dayjs(this.playlistDirty.active_from)
        const activeUntil = this.$dayjs(this.playlistDirty.active_until)

        const data = {
          content_type: PlaylistModel.CONTENT_TYPE_MARKETING,
          title: this.playlistDirty.title,
          description: this.playlistDirty.description,
          active_from: activeFrom.isValid() ? activeFrom.format('YYYY-MM-DD') : null,
          active_until: activeUntil.isValid() ? activeUntil.format('YYYY-MM-DD') : null,
          library_files: fileIds,
          client_id: this.client.id
        }

        let result

        if (this.playlist.id) {
          result = await Playlists.update(this.playlist.id, data)

          this.$emit('playlist:updated', result)

          this.$store.dispatch('alert', {
            text: 'Marketing campaign successfully updated',
            color: 'success'
          })
        } else {
          result = await Playlists.store(data)

          this.$emit('playlist:added', result)

          this.$store.dispatch('alert', {
            text: 'New marketing campaign successfully added',
            color: 'success'
          })
        }

        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There were some errors submitting marketing campaign',
          color: 'error'
        })
        console.error(e)
        throw e
      } finally {
        this.submitting = false
      }
    },
    async deletePlaylist() {
      this.deleting = true

      try {
        const result = await Playlists.delete([this.playlistDirty.id])

        this.$store.dispatch('alert', {
          text: 'Successfully deleted',
          color: 'success'
        })

        this.modalVisible = false
        this.$emit('playlist:deleted', result)
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'Something went wrong',
          color: 'error'
        })
        throw e
      } finally {
        this.deleteConfirmationDialogVisible = false
        this.deleting = false
      }
    },
    dragOver() {
      this.$refs.fileUploader.dragOver()
    },
    dragEnter() {
      this.$refs.fileUploader.dragEnter()
    },
    dragLeave() {
      this.$refs.fileUploader.dragLeave()
    },
    drop() {
      this.$refs.fileUploader.drop()
    },
    removeCurrentLibraryFile(file) {
      const index = this.currentLibraryFiles.findIndex(f => f.id === file.id)

      this.currentLibraryFiles.splice(index, 1)

      Playlists.removeFilesFromPlaylist(this.playlist.id, [file.id])
    },
    playAv(fileRecord) {
      if (fileRecord.stopAv) {
        fileRecord.stopAv()
        return
      }

      const player = document.createElement('audio')
      player.controls = true
      player.src = fileRecord.url
      player.play()
      fileRecord.isPlayingAv = true
      fileRecord.stopAv = () => {
        player.src = ''
        fileRecord.isPlayingAv = false
        fileRecord.stopAv = null
      }
    }
  }
}
</script>
